import $ from 'jquery/src/jquery'
import 'jquery-validation'
import Axios from 'axios'

export default () => {
    const nodeSelectors = {
        container: '[js-qa="container"]',

        form: '[js-qa="form"]',
        formErrorMessage: '[js-qa="form-error-message"]',
        inputHoneypot: '[js-qa="honeypot"]',
        input: '[js-qa="input"]',
        inputCharCounterCurrent: '[js-qa="input-char-counter-current"]',
        question: '[js-qa="question"]',
        movie: '[js-qa="movie"]',

        loader: '[js-qa="loader"]',

        // Info message
        formInfoMessage: '[js-qa="message"]',

        popupConfirmation: '[js-qa="popup-confirmation"]',
        popupConfirmationYes: '[js-qa="popup-confirmation-yes"]',
        popupConfirmationNo: '[js-qa="popup-confirmation-no"]',
        popupConfirmationLoader: '[js-qa="popup-confirmation-loader"]',

        popupSuccess: '[js-qa="popup-success"]',
        popupSuccessClose: '[js-qa="popup-success-close"]',
    }

    const COOLDOWN_SECONDS = ( site_data.timer ) ? site_data.timer : 0

    const $popupConfirmation = $(nodeSelectors.popupConfirmation)
    const $popupSuccess = $(nodeSelectors.popupSuccess)

    function init() {
        if (!document.querySelector(nodeSelectors.container)) return

        $(nodeSelectors.container).each(function () {
            const $container = $(this)
            const $form = $container.find(nodeSelectors.form)
            const $questionInput = $form.find(nodeSelectors.question)
            const $answerInput = $form.find(nodeSelectors.input)
            const $answerInputCharCounterCurrent = $form.find(nodeSelectors.inputCharCounterCurrent)

            // Load last submit time (if stored)
            const lastSubmit = parseInt(localStorage.getItem('qa_last_submit_' + $questionInput.val())) || 0
            const now = Date.now()
            if (now - lastSubmit < COOLDOWN_SECONDS * 1000) {
                disableForm($form, Math.ceil((COOLDOWN_SECONDS * 1000 - (now - lastSubmit)) / 1000))
            }

            $answerInput.on('input', function () {
                $answerInputCharCounterCurrent.text($answerInput.val().length)
            })

            // jQuery Validate setup
            $form.validate({
                errorElement: 'small',
                rules: {
                    answer: { required: true, minlength: 20, maxlength: 600 },
                },
                messages: {
                    answer: {
                        required: 'Unesi odgovor',
                        minlength: 'Tvoj odgovor mora imati makar 20 karaktera',
                        maxlength: 'Tvoj odgovor može imati maksimum 600 karaktera',
                    },
                },
                submitHandler: function (form, event) {
                    event.preventDefault()
                    if ($form.data('onCooldown')) return

                    // Show confirmation popup before submitting
                    showPopupConfirmation(() => {
                        sendAnswer($form)
                    })
                },
            })
        })
    }

    function sendAnswer($form) {
        $form.find(nodeSelectors.formErrorMessage).html('').hide();

        let $movieInput = $form.find(nodeSelectors.movie)
        let $answerInput = $form.find(nodeSelectors.input)
        let $questionInput = $form.find(nodeSelectors.question)
        let $loader = $form.find(nodeSelectors.loader)
        let $honeypotInput = $form.find(nodeSelectors.inputHoneypot)

        $loader.fadeIn()
        let questionID = $questionInput.val()

        const apiUrl = `${site_data.site_url}/wp-json/movies/v1/submit-answer`

        Axios.post(apiUrl, {
            answer: $answerInput.val(),
            movie_id: $movieInput.val(),
            question_id: questionID,
            website: $honeypotInput.val(),
        }, {
            headers: {
                'X-WP-Nonce': site_data.nonce,
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                // alert('Hvala! Tvoj odgovor je uspešno poslat.')
                // console.log('Answer submitted:', res.data)

                showPopupSuccess()
                localStorage.setItem('qa_last_submit_' + questionID, Date.now())

                if( COOLDOWN_SECONDS > 0 ) {
                    disableForm($form, COOLDOWN_SECONDS)
                }
            })
            .catch(err => {
                // alert('Došlo je do greške. Pokušaj ponovo.')
                // console.error('Error submitting answer:', err)

                let errorMessage = err.response.data.message

                if( !errorMessage ) {
                    errorMessage = 'Došlo je do greške. Pokušajte ponovo.'
                }

                $form.find(nodeSelectors.formErrorMessage).html(errorMessage).show();
            })
            .finally(() => {
                $loader.fadeOut()

                $popupConfirmation.fadeOut(200)
                $('html, body').removeClass('gl-no-scroll')
                $(nodeSelectors.popupConfirmationLoader).hide()
            })
    }

    function showPopupConfirmation(onConfirm) {
        $popupConfirmation.fadeIn(200)
        $('html, body').addClass('gl-no-scroll')

        $(nodeSelectors.popupConfirmationYes).one('click', function () {
            onConfirm()
            $(nodeSelectors.popupConfirmationLoader).show()
        })

        $(nodeSelectors.popupConfirmationNo).one('click', function () {
            $popupConfirmation.fadeOut(200)
            $('html, body').removeClass('gl-no-scroll')
        })
    }

    function showPopupSuccess() {
        $popupSuccess.fadeIn(200)
        $('html, body').addClass('gl-no-scroll')

        $(nodeSelectors.popupSuccessClose).one('click', function () {
            $popupSuccess.fadeOut(200)
            $('html, body').removeClass('gl-no-scroll')
        })
    }

    function disableForm($form, seconds) {
        let $infoMessage = $form.find(nodeSelectors.formInfoMessage)
        let $errorMessage = $form.find(nodeSelectors.formErrorMessage)

        $form.data('onCooldown', true)
        $form.find('input, button, textarea').prop('disabled', true)
        let remaining = seconds
        $infoMessage.text(`Sačekajte ${remaining}s pre ponovnog slanja.`).show()

        const interval = setInterval(() => {
            remaining--
            if (remaining <= 0) {
                clearInterval(interval)
                $form.find('input, button, textarea').prop('disabled', false)
                $form.data('onCooldown', false)
                $infoMessage.text('').hide()

                if( $errorMessage.find('.timer') ) {
                    $errorMessage.text('')
                }
            } else {
                $infoMessage.text(`Sačekajte ${remaining}s pre ponovnog slanja.`)

                if( $errorMessage.find('.timer') ) {
                    $errorMessage.find('.timer').text(remaining + 's')
                }
            }
        }, 1000)
    }

    return Object.freeze({ init })
}